// import SEGMENT_EVENTS from 'constants/segmentEvents';
//
// const MEMBERSHIP_BANNER_COOKIE_KEY = 'TL_MEMBERSHIP_BANNER_SHOW';

function Ctrl($scope, $state, $rootScope, $timeout, partnerService, membershipService, modalService, $window, utilsService) {
  $scope.partner = partnerService.partner;
  $scope.defaultCitySlug = utilsService.defaultCitySlug();

  $rootScope.showOverlayMenu = {
    hiding: true,
    hidden: true
  };

  $rootScope.isSubscribed = function() {
    return membershipService.isUserSubscribed();
  };

  $scope.isCheckoutPage = function() {
    return $state.current.name === 'app.checkout' ||
      $state.current.name === 'app.checkout-widget' ||
      $window.location.pathname.indexOf('/checkout') === 0 ||
      $window.location.pathname.indexOf('/checkout-widget') === 0;
  };

  //membership banner
  $scope.isHomePage = function() {
    return $state.current.name === 'app.home';
  };

  // $scope.goToMembership = function() {
  //   trackingService.trackEvent(SEGMENT_EVENTS.ClickedHomepageMembershipAd, {});
  //
  //   $scope.showMembershipBanner = false;
  //
  //   $state.go('app.membership.landing');
  // };

  // let cookieShowValue = $cookies.get(MEMBERSHIP_BANNER_COOKIE_KEY);
  //
  // if (!cookieShowValue && cookieShowValue !== 'FALSE') {
  //   cookieShowValue = $cookies.put(MEMBERSHIP_BANNER_COOKIE_KEY, 'TRUE');
  //
  //   cookieShowValue = 'TRUE';
  // }

  // $scope.showMembershipBanner = $scope.isHomePage() && cookieShowValue === 'TRUE';

  // $scope.hideMembershipBanner = function($event) {
  //   if ($event) $event.preventDefault();
  //
  //   $cookies.put(MEMBERSHIP_BANNER_COOKIE_KEY, 'FALSE');
  //
  //   $scope.showMembershipBanner = false;
  // };

  $scope.showNYEBanner = false;

  $scope.hideNYEBanner = function($event) {
    if ($event) $event.preventDefault();

    $scope.showNYEBanner = false;
  };

  //

  $scope.currentLogo = $scope.partner.logo;

  $scope.toggleOverlayMenu = function() {
    if ($rootScope.showOverlayMenu.hidden) {
      $rootScope.showOverlayMenu.hidden = false;
      $timeout(function() {
        $rootScope.showOverlayMenu.hiding = false;
      }, 100);
    } else {
      $rootScope.showOverlayMenu.hiding = true;
      $timeout(function() {
        $rootScope.showOverlayMenu.hidden = true;
      }, 400);
    }
  };

  $scope.openSearchModal = function() {
    modalService.search();
  };

  $rootScope.$on('$stateChangeSuccess', function() {
    if (!$rootScope.showOverlayMenu.hidden) {
      $scope.toggleOverlayMenu();
    }
  });
}

Ctrl.$inject = [
  '$scope',
  '$state',
  '$rootScope',
  '$timeout',
  'partnerService',
  'membershipService',
  'modalService',
  '$window',
  'utilsService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/appHeader/controller.js